import React from 'react';

const SurveyPreview = ({ CurrentTheme, GoodsState, CFTTotal, VehicleRequired, hideSurveyPreview }) => {
    return (
        <div id="SurveyPreviewModel" className="modal" style={{ display: "block", paddingTop: "60px" }}>
            <div className="modal-content">
                <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                    <span style={{ marginLeft: "5px", padding: "5px" }}>Goods Preview</span>
                    <span className="close" onClick={hideSurveyPreview}>&times;</span>
                </div>
                <div style={{ height: "40vh", overflow: "auto", overflowX: "hidden" }}>
                    <table className="table table-striped align-center">
                        <thead>
                            <tr>
                                <th style={{ position: "initial" }}>Name</th>
                                <th style={{ position: "initial" }}>Remarks</th>
                                <th style={{ position: "initial" }}>Quantity</th>
                                <th style={{ position: "initial" }}>CFT</th>
                            </tr>
                        </thead>
                        <tbody>
                            {GoodsState.length > 0 && GoodsState.map((goods, index) => (
                                <tr key={index}>
                                    <td>{goods.Name}</td>
                                    <td>{goods.Remarks}</td>
                                    <td>{goods.Quantity}</td>
                                    <td>{goods.CFTValue}</td>
                                </tr>
                            ))}
                            <tr style={{ backgroundColor: "#516fb9", color: "white" }}>
                                <td colSpan="3" style={{ fontSize: "1.2rem" }}>Total CFT / Vehicle Load</td>
                                <td style={{ fontSize: "1.5rem" }}>{CFTTotal} / {VehicleRequired}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default SurveyPreview;